import {getMethod} from '~/api'

async function get(request) {
    return await getMethod('/api/flightInfo', request)
}

export {get}
